module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/banner_common.a05bc71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product/banner_common.jpg
// module id = hVCZ
// module chunks = 0